
import router from "@/routes";
import { defineComponent, PropType, Ref, ref } from "vue";
import { EventCourse } from "../../../../domain/entities/courseEvent/courseEvent";
import {
  formatMenusDates,
  formatMenusSchedule,
  formatOneTime,
  formattedDate
} from "../mixins";
import NewContentEventFlag from "./flags/NewContentEventFlag.vue";
import VideoPlayButton from "./buttons/VideoPlay.vue";
import { useCarouselMouseEvents } from "../composables/carousel_mouse_events";

const __default__ = defineComponent({
  methods: {
    formatOneTime,
    formattedDate,
    formatMenusDates,
    formatMenusSchedule
  },
  components: { VideoPlayButton, NewContentEventFlag },
  props: {
    event: {
      type: Object as PropType<EventCourse>,
      required: true
    }
  },

  setup(props, { emit }) {
    /** Used to know if the user pressed the event card. */
    let pressed = false;

    /** Used to know if the user moved the event card. */
    let moved = false;

    /** Used to know if the user pressed the event card. */
    let released = false;

    /** Event's image to the background.
     * @see EventCourse.image. */
    const image: Ref<string> = ref(`url(${props.event.image})`);

    const { isAllowedToClick: isAllowedToOpenIntro } = useCarouselMouseEvents(
      "video-play-button"
    );
    const { isAllowedToClick: isAllowedToGoToCourse } = useCarouselMouseEvents(
      "event"
    );

    /** Controls if user is pressing the event card. */
    function pressing(): void {
      pressed = true;
    }

    /** Controls if user is moving the event card. */
    function moving(): void {
      if (!pressed) return;
      moved = true;
    }

    /** Controls if the event will open or not. */
    function releasing(): void {
      released = true;
      if (released && !moved) {
        openEvent();
      }
      pressed = false;
      moved = false;
      released = false;
    }

    /** Redirects the user the clicked event passing the event ID through the route params. */
    function openEvent(): void {
      if (!hasLowLevelActions && isAllowedToGoToCourse.value) {
        if (props.event.type === 1) {
          router.push({
            name: "event",
            params: {
              event_id: props.event.id,
              class_id: props.event.classID
            }
          });
        } else {
          router.push({
            name: "training-course",
            params: {
              trainingCourseID: props.event.id
            }
          });
        }
      }
      hasLowLevelActions = false;
    }

    /** Return the date formatted to locale date*/
    const toLocaleDate = (date: string) => {
      const options = {
        month: "numeric",
        year: "numeric",
        day: "numeric"
      };
      return new Date(date).toLocaleString("pt-br", options);
    };

    /** Return the time formatted to locale date/time*/
    const toLocaleTime = (date: string) => {
      const options = {
        hour: "numeric",
        minute: "numeric"
      };
      return new Date(date).toLocaleString("pt-br", options);
    };

    function isNewCourse(): boolean {
      const today = new Date().toISOString().slice(0, 10);

      if (props.event.releaseStartDate && props.event.releaseEndDate) {
        return (
          today >= props.event.releaseStartDate &&
          today <= props.event.releaseEndDate
        );
      }
      return (
        today >= props.event.releaseStartDate ||
        today <= props.event.releaseEndDate
      );
    }

    /** Boolean used to tell when a click event has been fired
     * from below the `div.card` in the DOM tree. */
    let hasLowLevelActions = false;

    const openIntroductoryContent = (): void => {
      if (isAllowedToOpenIntro.value) {
        emit("openIntroductoryContent");
        hasLowLevelActions = true;
      }
    };

    return {
      image,
      isNewCourse,
      moving,
      pressing,
      releasing,
      toLocaleDate,
      toLocaleTime,
      openIntroductoryContent
    };
  }
});

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "4cd62c82": (_ctx.image)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__